import { AxiosError, AxiosResponse } from 'axios'
import { useQuery } from 'react-query'
import toast from 'react-hot-toast'
import { Referral } from '@playback-rewards/shared-libraries'

//constants
import QueryKeys from 'constants/queryKeys'
//services
import { getReferees } from 'services/referalService'

const useQueryGetReferees = () => {
  const { data, isLoading } = useQuery<AxiosResponse<Referral[], Error>>(
    QueryKeys.GET_REFEREES,
    getReferees,
    {
      onError: (error) => {
        toast.error(
          ((error as AxiosError)?.response?.data as Error).message || 'Something went wrong!'
        )
      },
    }
  )

  return {
    isLoadingReferees: isLoading,
    referees: data?.data ?? [],
  }
}

export default useQueryGetReferees
